import { mobileSidebarToggleEventId, sidebarToggleEventId } from '../sidebarState.constants';
import { getIsSidebarOpen } from './getSidebarStateStorage';

/* TODO: Mobile state storage? */
function createSidebarEventEmitter(eventId) {
  return function emitEvent(enforcedValue) {
    window.dispatchEvent(new CustomEvent(eventId, {
      detail: {
        opened: enforcedValue !== undefined ? enforcedValue : !getIsSidebarOpen()
      }
    }));
  };
}
export const emitDesktopSidebarToggleEvent = createSidebarEventEmitter(sidebarToggleEventId);
export const emitMobileSidebarToggleEvent = createSidebarEventEmitter(mobileSidebarToggleEventId);